// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* BORDERS */\n\n/* Icons */\n\n.v-list-item-group .v-list-item--active {\n  color: inherit;\n}", ""]);
// Exports
module.exports = exports;
